const smartFieldStyle = {
  userSelect: 'none',
  backgroundColor: '#f3f3f3',
  border: '1px solid #ccc',
  padding: '2px 4px',
  borderRadius: '4px',
  display: 'inline-block'
};

const FinancialTable = () => {
  return (
    <table contentEditable={false} id="financialTable" border="1" style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'center' }}>
      <thead>
        <tr>
          <th contentEditable={false}></th>
          <th contentEditable={false}>Montant de la prestation (Net de taxe)</th>
          <th contentEditable={false}>Montant du niveau de prise en charge OPCO</th>
          <th contentEditable={false}>Reste à charge éventuel de l'entreprise (Net de taxe)</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4].map((year) => (
          <tr key={year}>
            <td contentEditable={false}>Année {year} de financement </td>
            <td><span data-smartfield={`[prestation${year}/]`} contentEditable={false} style={smartFieldStyle}>Montant Prestation {year}</span></td>
            <td><span data-smartfield={`[opco${year}/]`} contentEditable={false} style={smartFieldStyle}>Montant OPCO {year}</span></td>
            <td><span data-smartfield={`[entreprise${year}/]`} contentEditable={false} style={smartFieldStyle}>Montant Entreprise {year}</span></td>
          </tr>
        ))}
        <tr>
          <td contentEditable={false}>Total</td>
          <td><span data-smartfield="[prestationTotal/]" contentEditable={false} style={smartFieldStyle}>Total Prestation</span></td>
          <td><span data-smartfield="[opcoTotal/]" contentEditable={false} style={smartFieldStyle}>Total OPCO</span></td>
          <td><span data-smartfield="[entrepriseTotal/]" contentEditable={false} style={smartFieldStyle}>Entreprise Total</span></td>
        </tr>
      </tbody>
    </table>
  );
};

export default FinancialTable;